AuthRoute = require 'mixins/authenticated-route'

###
# List all couriers
###
App.RestaurantsIndexRoute = Em.Route.extend(AuthRoute)